import profilePicture from "../images/IMG_1503-2.jpg";

function CVProfilePicture() {
    return <img src={profilePicture} width="200px" class="rounded" alt="Jonathan Schoreels"/>;
}

export default CVProfilePicture